import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectListOption } from '@bmw-ds/components';

@Injectable({
    providedIn: 'root'
})
export class SeraDropdownMapperService {
    constructor(private translateService: TranslateService) {}

    translateDropdownOptions(seraDropdownOptions: SelectListOption[]): SelectListOption[] {
        seraDropdownOptions.forEach(option => {
            option.label = this.translateService.instant(option.label);
        });
        return seraDropdownOptions;
    }

    filterAndTranslateDropdownOptions(seraDropdownOption: SelectListOption[], enabledOptions: string[]) {
        seraDropdownOption.forEach(option => {
            option.label = this.translateService.instant(option.label);
            option.disabled = !enabledOptions.some(a => a === option.id);
        });
    }
}
